import {DragAndDropFiles} from "../../../components/drag-and-drop-file/DragAndDropFiles";
import {useAtom} from "jotai";
import {AnswerAtom} from "../atoms";
import {toast} from "react-toastify";
import {Grid, IconButton, Tooltip, Typography} from "@mui/material";
import {IconFile, IconX} from "@tabler/icons-react";
import {confirm} from "react-confirm-box";
import {confirmDialogOptions} from "../../../components/ConfirmDialog";
import {getFileIcon} from "../../../utils/functions";
import React from "react";


export const FileUploadQuestion = () => {
  const [answer, setAnswer] = useAtom(AnswerAtom);

  const deleteFile = async (index) => {
    const fileName = answer?.files[index]?.name || "";
    const response = await confirm(
      {
        title: `Are you sure you want to delete this file?`,
        subtitle: fileName,
        confirmText: "Yes, Delete",
        cancelText: "No",
      },
      confirmDialogOptions,
    );
    if (response) {
      setAnswer(prev => ({...prev, files: prev?.files?.filter((i, ind) => ind !== index) || []}))
    }
  }

  return (
    <>
      <DragAndDropFiles
        multiple={false}
        maxFileSize={answer?.max_file_size}
        types={answer?.file_types?.map(i => i?.replaceAll(".", "")?.toUpperCase())}
        disabled={answer?.files?.length >= answer?.max_files && answer?.files?.length > 0}
        maxFiles={answer?.max_files || 1}
        onUpdate={(file) => {
          if (!answer?.files || answer?.files.length < answer?.max_files) {
            setAnswer(prev => ({
              ...prev,
              files: [...(prev?.files || []), file],
            }))
          } else {
            toast.error(`File upload limit of ${answer?.max_files} has been reached.`);
          }
        }}
      />
      <Grid container spacing={2} sx={{mt: 1}}>
        {answer?.files?.map((file, index) => (
          <Grid item xs={3} md={2} key={index} sx={{position: "relative", display: "flex", alignItems: "center", flexDirection: "column"}}>
            <Tooltip title={"Remove this file"}>
              <IconButton
                size={"small"}
                onClick={() => deleteFile(index)}
                sx={{
                  position: "absolute", top: 0, right: 0,
                  transform: "translate(50%)", p: 0.25,
                  color: "#fefefe", bgcolor: "error.main",
                  "&:hover": {bgcolor: "error.dark"}
                }}
              >
                <IconX size={13}/>
              </IconButton>
            </Tooltip>
            {getFileIcon(file?.name) || <IconFile size={30}/>}

            {/*<IconFile size={30}/>*/}
            <Typography fontSize={11} noWrap sx={{maxWidth: "95%"}}>{file?.name}</Typography>
            <Typography fontSize={11} sx={{maxWidth: "95%"}}>{((file?.size / (1024 * 1024)) || 0)?.toFixed(2)}MB.</Typography>
          </Grid>
        ))}
      </Grid>
    </>
  )
}